import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import RichTextField from '@/components/common/RichTextField.vue';
import MediaList from '@/components/media/MediaList.vue';
import { InfoItem } from '@/models/info-item.model';
import { ref, PropType, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoContentForm',
  props: {
  modelValue: { type: Object as PropType<InfoItem>, required: true },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const value = ref<InfoItem>({ ...props.modelValue });

const emit = __emit;

const update = () => {
  emit('update:modelValue', value.value);
};

watch(
  () => props.modelValue,
  () => {
    Object.assign(value.value, props.modelValue);
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: value.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value.value.title) = $event)),
              label: "Title",
              onChange: update,
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(RichTextField, {
              label: "Description",
              modelValue: value.value.description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value.value.description) = $event)),
              onChange: update,
              media: __props.modelValue.media
            }, null, 8, ["modelValue", "media"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(MediaList, {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value).value = $event)),
      onChange: update
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})